module.exports = __webpack_public_path__ + "img/gift_bg_popup_2.dacd0a9.png";